/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimplePricingDTO
 */
export interface SimplePricingDTO {
    /**
     * 
     * @type {number}
     * @memberof SimplePricingDTO
     */
    currentValue: number;
    /**
     * 
     * @type {number}
     * @memberof SimplePricingDTO
     */
    unitPriceInCents: number;
}

/**
 * Check if a given object implements the SimplePricingDTO interface.
 */
export function instanceOfSimplePricingDTO(value: object): value is SimplePricingDTO {
    if (!('currentValue' in value) || value['currentValue'] === undefined) return false;
    if (!('unitPriceInCents' in value) || value['unitPriceInCents'] === undefined) return false;
    return true;
}

export function SimplePricingDTOFromJSON(json: any): SimplePricingDTO {
    return SimplePricingDTOFromJSONTyped(json, false);
}

export function SimplePricingDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimplePricingDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'currentValue': json['currentValue'],
        'unitPriceInCents': json['unitPriceInCents'],
    };
}

export function SimplePricingDTOToJSON(value?: SimplePricingDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'currentValue': value['currentValue'],
        'unitPriceInCents': value['unitPriceInCents'],
    };
}

